import React from 'react';
import { Body1Strong, makeStyles } from '@fluentui/react-components';
import { useDataSource } from '@bingads-webui-react/data-source';
import NoSearchResultsIcon from './no-search-results-icon';
import { I18n } from '../types';

const useStyles = makeStyles({
  wrapper: {
    textAlign: 'center',
    paddingTop: '40px',
    paddingBottom: '40px',
  },
  message: {
    textAlign: 'center',
    display: 'block',
  },
});

const NoSearchResultsMessage = ({ i18n, showSelectedOnly }: { i18n: I18n, showSelectedOnly: boolean }) => {
  const classes = useStyles();
  const { searchTerm } = useDataSource();
  const searchTermTrimmed = searchTerm.trim();

  const message = showSelectedOnly
    ? i18n.getString(_TL_('No results found for "{{searchTerm}}" in the selected items.'), { searchTerm: searchTermTrimmed })
    : i18n.getString(_TL_('No results found for "{{searchTerm}}".'), { searchTerm: searchTermTrimmed });

  return (
    <div className={classes.wrapper}>
      <NoSearchResultsIcon alt={i18n.getString(_TL_('No search results icon'))} />
      <Body1Strong className={classes.message}>{message}</Body1Strong>
    </div>
  );
};

export default NoSearchResultsMessage;
